export default __webpack_public_path__ + "static/media/favivon.af9b9372.png";